var _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
import { CheckBox } from "grommet";
export var StyledWrapper = styled.div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  border-bottom-right-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n",
    ]))
);
export var StyledParagraph = styled.p(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  text-align: right;\n  margin-bottom: 1.5rem;\n  margin-right: 0.5rem;\n  font-size: 0.75rem;\n",
    ]))
);
export var StyledInfo = styled.div(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  margin-bottom: 2rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(9.3rem, 1fr));\n",
    ]))
);
export var StyledInfoParagraph = styled.p(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteralLoose([
      "\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n",
    ]))
);
export var StyledCheckboxWrap = styled.div(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteralLoose([
      "\n  white-space: nowrap;\n  font-size: 0.75rem;\n  line-height: 1.4;\n",
    ]))
);
export var StyledInfoText = styled.p(
  _templateObject6 ||
    (_templateObject6 = _taggedTemplateLiteralLoose([
      "\n  font-size: 0.625rem;\n  margin-left: 2.5rem;\n",
    ]))
);
export var StyledInfoCount = styled.p(
  _templateObject7 ||
    (_templateObject7 = _taggedTemplateLiteralLoose([
      "\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n",
    ]))
);
export var StyledCount = styled.p(
  _templateObject8 ||
    (_templateObject8 = _taggedTemplateLiteralLoose([
      "\n  font-size: 0.75rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  margin-left: -5px;\n  margin-right: 5px;\n",
    ]))
);
export var StyledBtnWrap = styled.div(
  _templateObject9 ||
    (_templateObject9 = _taggedTemplateLiteralLoose([
      "\n  display: flex;\n  align-items: center;\n",
    ]))
);
export var StyledButton = styled.button(
  _templateObject10 ||
    (_templateObject10 = _taggedTemplateLiteralLoose([
      "\n  background-color: transparent;\n  border: none;\n  color: black;\n  padding: 0;\n  width: 2rem;\n  height: 2rem;\n  margin-bottom: 0.6rem;\n  margin-left: -10px;\n",
    ]))
);
export var StyledPrice = styled.p(
  _templateObject11 ||
    (_templateObject11 = _taggedTemplateLiteralLoose(["\n  text-align: right;\n"]))
);
export var StyledBox = styled.div(
  _templateObject12 ||
    (_templateObject12 = _taggedTemplateLiteralLoose(["\n  margin-left: 4rem;\n"]))
);
export var StyledCheckBox = styled(CheckBox)(
  _templateObject13 ||
    (_templateObject13 = _taggedTemplateLiteralLoose(["\n  border-radius: 50%;\n"]))
);
export var StyledTotalPrice = styled.div(
  _templateObject14 ||
    (_templateObject14 = _taggedTemplateLiteralLoose([
      "\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  font-weight: 700;\n",
    ]))
);
export var StyledNextPrice = styled.div(
  _templateObject15 ||
    (_templateObject15 = _taggedTemplateLiteralLoose(["\n  font-size: 0.75rem;\n"]))
);
export var StyledButtonCart = styled.div(
  _templateObject16 ||
    (_templateObject16 = _taggedTemplateLiteralLoose([
      "\n  padding: 0.8rem;\n  width: 100%;\n  background-color: #c7252b;\n  color: white;\n  border: unset;\n  border-radius: 50px;\n  text-align: center;\n  margin-bottom: 1rem;\n  opacity: ",
      ";\n  pointer-events: ",
      ";\n  cursor: pointer;\n",
    ])),
  function (props) {
    return props.disabled && 0.5;
  },
  function (props) {
    return props.disabled ? "none" : "all";
  }
);
